jQuery(function () {
    var header = jQuery(".site-header");
    var html = jQuery("html");
    jQuery(window).scroll(function () {
        var scroll = jQuery(window).scrollTop();
        if (scroll >= 100) {
            header.addClass("-is-floating");
            html.addClass("has-floating-nav");
        }
        else {
            header.removeClass("-is-floating");
            html.removeClass("has-floating-nav");
        }
    });
});
